export function numberGenerator(start: number, end: number): number[] {
    const numbers: number[] = [];
    for (let i = start; i <= end; i++) {
        numbers.push(i);
    }
    return numbers;
}